/**
 * Include your custom JavaScript here.
 * CheckoutGuard now handles all add-to-cart restrictions.
 */

(function() {

  /**
   * SEO URL Cleaner
   * Strips tracking parameters from product links to ensure canonical URLs are used.
   * Addresses: pr_prod_strat, pr_rec_id, pr_rec_pid, pr_ref_pid, pr_seq (recommendations)
   *            _pos, _sid, _ss (search/filtering)
   */
  const SEO_URL_CLEANER = {
    // Parameters to remove from product URLs
    paramsToRemove: [
      'pr_prod_strat',
      'pr_rec_id',
      'pr_rec_pid',
      'pr_ref_pid',
      'pr_seq',
      '_pos',
      '_sid',
      '_fid',
      '_ss',
      '_psq',
      '_v'
    ],

    /**
     * Clean a single URL by removing tracking parameters
     * @param {string} href - The URL to clean
     * @returns {string} - The cleaned URL
     */
    cleanUrl: function(href) {
      if (!href || !href.includes('?')) return href;

      try {
        const url = new URL(href, window.location.origin);
        let hasParams = false;

        this.paramsToRemove.forEach(function(param) {
          if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            hasParams = true;
          }
        });

        // Return cleaned URL (without empty query string)
        if (hasParams) {
          return url.searchParams.toString() ? url.pathname + '?' + url.searchParams.toString() + url.hash : url.pathname + url.hash;
        }
      } catch (e) {
        // Invalid URL, return original
      }

      return href;
    },

    /**
     * Clean all product links within a container
     * @param {Element} container - The container to search within
     */
    cleanLinks: function(container) {
      const self = this;
      const productLinkSelector = 'a[href*="/products/"]';
      const links = container.querySelectorAll(productLinkSelector);

      links.forEach(function(link) {
        const originalHref = link.getAttribute('href');
        const cleanedHref = self.cleanUrl(originalHref);

        if (originalHref !== cleanedHref) {
          link.setAttribute('href', cleanedHref);
        }
      });
    },

    /**
     * Initialize the URL cleaner with MutationObserver for dynamic content
     */
    init: function() {
      var self = this;

      // Clean existing links on page load
      this.cleanLinks(document.body);

      // Debounced MutationObserver — batches rapid DOM mutations (e.g. mini-cart
      // re-render with 100+ items) into a single cleanup pass instead of
      // firing querySelectorAll per added node.
      var pendingContainers = [];
      var debounceTimer = null;

      function flushPending() {
        var containers = pendingContainers;
        pendingContainers = [];
        debounceTimer = null;
        for (var i = 0; i < containers.length; i++) {
          // Only clean if the node is still in the DOM
          if (containers[i].isConnected !== false) {
            self.cleanLinks(containers[i]);
          }
        }
      }

      var observer = new MutationObserver(function(mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var addedNodes = mutations[m].addedNodes;
          for (var n = 0; n < addedNodes.length; n++) {
            if (addedNodes[n].nodeType === Node.ELEMENT_NODE) {
              pendingContainers.push(addedNodes[n]);
            }
          }
        }
        if (pendingContainers.length > 0 && !debounceTimer) {
          debounceTimer = setTimeout(flushPending, 150);
        }
      });

      // Only observe direct children of body (not deep subtree) — product links
      // are added as top-level section replacements, not deep nested insertions.
      // Falls back to subtree for safety.
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  // Initialize SEO URL Cleaner when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      SEO_URL_CLEANER.init();
    });
  } else {
    SEO_URL_CLEANER.init();
  }

  // Polyfill for smooth scroll (if not supported)
  if (!('scrollBehavior' in document.documentElement.style)) {
    window.scrollTo = function(options) {
      window.scroll({
        top: options.top,
        left: options.left,
        behavior: 'auto' // Fallback for smooth scroll
      });
    };
  }

  // DOMContentLoaded extras
  document.addEventListener('DOMContentLoaded', function() {
    const featuredCollections = document.querySelectorAll("[data-featured-collection]");
    if (featuredCollections.length > 0) {
      const firstFeaturedCollection = featuredCollections[0]; // Get first section
      const images = firstFeaturedCollection.querySelectorAll(".js-product-image");

      images.forEach(function(image){
        image.setAttribute("loading", "eager");
      });
    }
  });

  // Auto-close mini-cart on scroll down (throttled to avoid firing 60×/sec)
  var lastScrollPosition = 0;
  var scrollThrottled = false;
  window.addEventListener('scroll', function () {
    if (scrollThrottled) return;
    scrollThrottled = true;
    setTimeout(function() { scrollThrottled = false; }, 200);

    var currentScrollPosition = window.scrollY;

    if (currentScrollPosition > lastScrollPosition && currentScrollPosition > 600) {
      var cartToggle = document.querySelector('.header__cart-toggle');

      if (cartToggle && cartToggle.getAttribute('aria-expanded') === 'true') {
        cartToggle.click();
      }
    }

    lastScrollPosition = currentScrollPosition;
  });

// Single Issue Banner

  const allowedUrls = [
    "/pages/managecomics", // add more pages if you want to allow this to appear in other pages as well
  ];

  const currentPath = window.location.pathname;

  if (!allowedUrls.includes(currentPath)) return;

  const target = document.getElementById("managecomics");
  if (target) {
    const container = document.createElement("div");
    container.className = "single-issue-info-banner";

    const link = document.createElement("a");
    link.href = "/pages/walt-s-pullbox-easy-comic-book-pre-orders-subscriptions";
    link.className = "single-issue-info";
    link.textContent = "Please read this Info Page carefully before ordering with Manage Comics!";

    container.appendChild(link);
    target.parentNode.insertBefore(container, target);
  }

})();